"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AddQuestionSection = _interopRequireDefault(require("./AddQuestionSection"));

var _constants = require("../utils/constants");

var _card = require("@jsluna/card");

var _grid = require("@jsluna/grid");

var _uuid = require("uuid");

var _defaultValues = _interopRequireDefault(require("./data/defaultValues"));

var _QuestionBuilder = _interopRequireDefault(require("./QuestionBuilder"));

var _QuestionPreview = _interopRequireDefault(require("./QuestionPreview"));

var _BranchOptionModal = _interopRequireDefault(require("./BranchOptionModal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var getDefaultValues = function getDefaultValues(type) {
  return JSON.parse(JSON.stringify(_defaultValues.default)).filter(function (x) {
    return x.component.type === type;
  })[0];
};

var SurveyBuilder = function SurveyBuilder(_ref) {
  var questions = _ref.questions,
      setQuestions = _ref.setQuestions;

  var _useState = (0, _react.useState)(false),
      showOptions = _useState[0],
      setShowOptions = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      isBranchModalOpen = _useState2[0],
      setIsBranchModalOpen = _useState2[1];

  var _useState3 = (0, _react.useState)({
    id: null,
    value: null
  }),
      branchFrom = _useState3[0],
      setBranchFrom = _useState3[1];

  var handleAddQuestion = function handleAddQuestion(type) {
    var newQuestion = Object.assign({}, getDefaultValues(type), {
      id: (0, _uuid.v1)(),
      position: questions.length + 1,
      editMode: true,
      state: _constants.questionStates.new
    });
    setQuestions([].concat(questions, newQuestion));
  };

  var setEditMode = function setEditMode(id) {
    var copy = [].concat(questions);
    var index = copy.findIndex(function (x) {
      return x.id === id;
    });
    copy[index].editMode = true;
    setQuestions(copy);
  };

  var handleSetBranchFrom = function handleSetBranchFrom(id, value) {
    setBranchFrom({
      id: id,
      value: value
    });
    setIsBranchModalOpen(true);
  };

  return /*#__PURE__*/_react.default.createElement("div", null, isBranchModalOpen && /*#__PURE__*/_react.default.createElement(_BranchOptionModal.default, {
    questions: questions,
    setQuestions: setQuestions,
    branchFromId: branchFrom.id,
    branchFromValue: branchFrom.value,
    isOpen: isBranchModalOpen,
    setIsOpen: setIsBranchModalOpen
  }), /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, questions.length > 0 && questions.map(function (x) {
    return x.editMode ? /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      key: x.id,
      size: "1/1",
      className: "ln-u-padding-ends"
    }, /*#__PURE__*/_react.default.createElement(_card.Card, {
      className: "ln-u-bg-color-light"
    }, /*#__PURE__*/_react.default.createElement(_QuestionBuilder.default, {
      key: (0, _uuid.v1)(),
      initial: x,
      questions: questions,
      setQuestions: setQuestions,
      setBranchFrom: handleSetBranchFrom
    }))) : /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
      size: "1/1",
      key: x.id,
      className: "ln-u-padding-ends"
    }, /*#__PURE__*/_react.default.createElement(_QuestionPreview.default, {
      question: x,
      setEditMode: setEditMode
    }));
  }), questions.filter(function (x) {
    return x.state === _constants.questionStates.new;
  }).length === 0 && /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1",
    className: "ln-u-padding-ends"
  }, /*#__PURE__*/_react.default.createElement(_AddQuestionSection.default, {
    options: _constants.SURVEY_OPTIONS,
    addQuestion: handleAddQuestion,
    showOptions: showOptions,
    setShowOptions: setShowOptions
  }))));
};

SurveyBuilder.propTypes = {
  /** The questions state to be updated by the survey builder */
  questions: _propTypes.default.array.isRequired,

  /** Function to extract the survey information from this component */
  setQuestions: _propTypes.default.func.isRequired
};
var _default = SurveyBuilder;
exports.default = _default;